import {sumBy} from 'lodash';
import {getNumericValue} from '../common/util/fieldsValidation';

const WIDTH_CELL = 250;
const WIDTH_TITLE = 400;

const renderType = (type) => {
  if (type === 'REPUESTOS') {
    return 'R';
  } else if (type === 'ACCESORIOS') {
    return 'A';
  }
  return 'L';
};

export const parseHeaders = (data) => {
  const header = data.map((key) => {
    if (key !== 'type') {
      return {'value': key.toUpperCase(), 'width': WIDTH_CELL, 'readOnly': true};
    }
    return {'value': ' ', 'width': WIDTH_TITLE, 'readOnly': true};
  });
  header.push({'value': 'TOTAL', 'width': WIDTH_CELL, 'readOnly': true});
  return header;
};

export const getAllTotals = (data, detail) => {
  let total = 0;
  data.forEach((element) => {
    total += detail.reduce((accum, currentValue) => {
      if (currentValue !== 'type') {
        accum += element[currentValue]; // eslint-disable-line no-param-reassign
      }
      return accum;
    }, 0);
  });
  return total;
};

export const parseResults = (data, detail) => {
  const result = data.map((element) => {
    const totalByType = detail.reduce((accum, currentValue) => {
      if (currentValue !== 'type') {
        accum += element[currentValue]; // eslint-disable-line no-param-reassign
      }
      return accum;
    }, 0);

    const detailResult = detail.map((key) => {
      if (key !== 'type') {
        return {
          'value': getNumericValue(element[key], 2),
          'width': WIDTH_CELL,
          'readOnly': false,
        };
      }
      return {'value': element[key], 'width': WIDTH_TITLE, 'readOnly': true};
    });
    detailResult.push({
      'value': getNumericValue(totalByType, 2),
      'width': WIDTH_CELL,
      'readOnly': true,
    });
    return detailResult;
  });
  return result;
};

export const parseTotalValues = (arr, detail, totals) => {
  const totalValues = detail.map((key) => {
    if (key !== 'type') {
      return {
        'value': getNumericValue(sumBy(arr, key), 2),
        'width': WIDTH_CELL,
        'readOnly': true,
      };
    }
    return {'value': 'TOTAL', 'width': WIDTH_TITLE, 'readOnly': true};
  });
  totalValues.push({
    'value': getNumericValue(totals, 2),
    'width': WIDTH_CELL,
    'readOnly': true,
  });
  return totalValues;
};

export const parseData = (data = [], year) => {
  const sliceData = data.slice(1, data.length);
  sliceData.pop();
  const result = [];

  sliceData.forEach((arr, idx) => {
    const data = [];
    const type = arr[0].value;
    arr.forEach((element, index) => {
      if (index >= 1 && index <= 12) {
        const valueFormatted = element.value ?
          element.value.replace(/[$,]/g, '') :
          0;
        data.push({
          'type': renderType(type),
          year,
          'month': index,
          'budget': valueFormatted,
        });
      }
    });
    result.push(data);
  });
  return result.flat();
};
